import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import MetisMenu from 'metismenujs';
import * as _ from 'lodash';

import { MyMenu } from './menu';
import { MenuItem } from '@app/models';
import { AuthenticationService, DataService, LocalService, SharedClickService } from '@app/services';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {
  private readonly sidebarFoldedStorageKey = 'sidebar-folded';

  utilisateur: any;

  counts: any;
  received: number;
  sent: number;

  @ViewChild('sidebarToggler') sidebarToggler: ElementRef;
  @ViewChild('sidebarMenu') sidebarMenu: ElementRef;

  menuItems: MenuItem[] = [];

  subscriptionProp: any;

  constructor(
    @Inject(DOCUMENT) private document: Document, 
    router: Router,
    private dataService: DataService,
    private mymenu: MyMenu,
    private sharedClickService: SharedClickService,
    private authenticationService: AuthenticationService,
    private localService: LocalService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {

        // Activating the current active item dropdown
        this._activateMenuDropdown();

        // closing the sidebar
        if (window.matchMedia('(max-width: 991px)').matches) {
          this.document.body.classList.remove('sidebar-open');
        }
      }
    });
  }

  // Toggle sidebar on hamburger button click
  toggleSidebar(e: Event) {
    this.sidebarToggler.nativeElement.classList.toggle('active');
    this.sidebarToggler.nativeElement.classList.toggle('not-active');
    if (window.matchMedia('(min-width: 992px)').matches) {
      e.preventDefault();
      this.setSidebarFolded(!this.document.body.classList.contains('sidebar-folded'));
    } else if (window.matchMedia('(max-width: 991px)').matches) {
      e.preventDefault();
      this.document.body.classList.toggle('sidebar-open');
    }
  }

  // Open sidebar when hover (in folded folded state)
  operSidebarFolded() {
    if (this.document.body.classList.contains('sidebar-folded')){
      this.document.body.classList.add("open-sidebar-folded");
    }
  }

  // Fold sidebar after mouse leave (in folded state)
  closeSidebarFolded() {
    if (this.document.body.classList.contains('sidebar-folded')){
      this.document.body.classList.remove("open-sidebar-folded");
    }
  }

  private setSidebarFolded(folded: boolean) {
    this.document.body.classList.toggle('sidebar-folded', folded);
    this.document.body.classList.remove('open-sidebar-folded');
    this.localService.setJsonValue(this.sidebarFoldedStorageKey, folded);

    if (this.sidebarToggler?.nativeElement) {
      this.sidebarToggler.nativeElement.classList.toggle('active', !folded);
      this.sidebarToggler.nativeElement.classList.toggle('not-active', folded);
    }
  }

  private restoreSidebarState() {
    const savedState = this.localService.getJsonValue(this.sidebarFoldedStorageKey);
    this.document.body.classList.toggle('sidebar-folded', savedState === true || savedState === 'true');
  }

  private handleViewportChange(mq: MediaQueryList) {
    if (mq.matches) {
      this.restoreSidebarState();
      return;
    }

    this.document.body.classList.remove('sidebar-folded', 'open-sidebar-folded');
  }

  // Returns true or false if given menu item has child or not
  /* @param item menuItem */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  // Reset the menus then highlight current active menu item
  _activateMenuDropdown() {
    this.resetMenuItems();
    this.activateMenuItems();
  }

  // Resets the menus
  resetMenuItems() {
    const links = document.getElementsByClassName('nav-link-ref');
    
    for (let i = 0; i < links.length; i++) {
      const menuItemEl = links[i];
      menuItemEl.classList.remove('mm-active');
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
          parentEl.classList.remove('mm-active');
          const parent2El = parentEl.parentElement;
          
          if (parent2El) {
            parent2El.classList.remove('mm-show');
          }

          const parent3El = parent2El?.parentElement;
          if (parent3El) {
            parent3El.classList.remove('mm-active');

            if (parent3El.classList.contains('side-nav-item')) {
              const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

              if (firstAnchor) {
                firstAnchor.classList.remove('mm-active');
              }
            }

            const parent4El = parent3El.parentElement;
            if (parent4El) {
              parent4El.classList.remove('mm-show');

              const parent5El = parent4El.parentElement;
              if (parent5El) {
                parent5El.classList.remove('mm-active');
              }
            }
          }
      }
    }
  };

  // Toggles the menu items
  activateMenuItems() {
    const links: any = document.getElementsByClassName('nav-link-ref');

    let menuItemEl = null;
    
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
        if (window.location.pathname === links[i]['pathname']) {
          
            menuItemEl = links[i];
            
            break;
        }
    }

    if (menuItemEl) {
        menuItemEl.classList.add('mm-active');
        const parentEl = menuItemEl.parentElement;

        if (parentEl) {
            parentEl.classList.add('mm-active');

            const parent2El = parentEl.parentElement;
            if (parent2El) {
                parent2El.classList.add('mm-show');
            }

            const parent3El = parent2El.parentElement;
            if (parent3El) {
                parent3El.classList.add('mm-active');

                if (parent3El.classList.contains('side-nav-item')) {
                    const firstAnchor = parent3El.querySelector('.side-nav-link-a-ref');

                    if (firstAnchor) {
                        firstAnchor.classList.add('mm-active');
                    }
                }

                const parent4El = parent3El.parentElement;
                if (parent4El) {
                    parent4El.classList.add('mm-show');

                    const parent5El = parent4El.parentElement;
                    if (parent5El) {
                        parent5El.classList.add('mm-active');
                    }
                }
            }
        }
    }
  };

  onLinkClick(): void {
    this.sharedClickService.triggerSupportClick.next();
  }

  //subscribe to all events changes
  subMenu(){
      //detecte changement dans les badges propositions
      this.subscriptionProp = this.dataService.currentMessage.subscribe(
        res => {
          if(res?.counts) {
            this.counts = res.counts;
            if(this.counts){
              this.received = this.counts.received || 0;
              this.sent = this.counts.sent || 0;
              this.menuItems = this.mymenu.getMenu(this.received,this.sent);
            }
          }
        }
      );
  }

  // Afficher en fonction du role user
  accessLink(){
    return this.authenticationService.isUser() || this.authenticationService.isDealer();
  }

  ngOnInit(): void {
    this.subMenu();

    // On desktop, restore the user's saved folded/open preference.
    const desktopMedium = window.matchMedia('(min-width:992px)');
    desktopMedium.addEventListener('change', () => {
      this.handleViewportChange(desktopMedium);
    });
    this.handleViewportChange(desktopMedium);
  }

  ngAfterViewInit() {
    const isFolded = this.document.body.classList.contains('sidebar-folded');
    this.sidebarToggler.nativeElement.classList.toggle('active', !isFolded);
    this.sidebarToggler.nativeElement.classList.toggle('not-active', isFolded);

    // activate menu item
    new MetisMenu(this.sidebarMenu.nativeElement);
    
    this._activateMenuDropdown();
  }

  ngOnDestroy(): void {
    this.subscriptionProp.unsubscribe();
  }
}
